var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02779 8.8666L13.6663 0.228095C13.815 0.0792616 13.989 0.00326167 14.1883 9.50001e-05C14.3876 -0.00307167 14.5649 0.0729282 14.72 0.228095C14.8752 0.383262 14.9528 0.561428 14.9528 0.762595C14.9528 0.963928 14.8752 1.14218 14.72 1.29734L5.66054 10.3723C5.47971 10.553 5.26879 10.6433 5.02779 10.6433C4.78679 10.6433 4.57587 10.553 4.39504 10.3723L0.22004 6.19734C0.0713732 6.04851 -0.00196018 5.87184 3.9823e-05 5.66734C0.00187316 5.46301 0.0803731 5.28326 0.23554 5.12809C0.390706 4.97293 0.568873 4.89534 0.77004 4.89534C0.971373 4.89534 1.14962 4.97293 1.30479 5.12809L5.02779 8.8666Z",
    fill: "#3F3273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.3b579057278d383e529655350a07e9c7.svg";
export { ForwardRef as ReactComponent };